<template>

    <v-card class="rad">
        <v-card-title class="naslov-kartice">
          <span class="glif">&#9632;</span> Trošak radnika
          <span class="smjer">ulazi u koštanje</span>
          <span class="znak">{{ items.length }} {{ mnozinaStavke }}</span>
          <v-spacer></v-spacer>
          <span class="iznos">{{ localMoney(zbrojSkupine) }}</span>
          <v-btn icon small color="primary" class="ml-2" @click="newMaterial" title="Dodaj stavku">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </v-card-title>
        <!-- Rad se ne bira iz sifrarnika artikala: upisuje se radnik, datum,
             sati i satnica, plus dnevnice i kilometri. Iznos je
             sati x satnica + dnevnice + kilometri, isto kako racuna i
             postojeci ekran ("calculatePriceWrk"). -->
        <div class="unos unos-rad" v-if="!locked">
          <v-text-field ref="radnik" outlined dense hide-details="auto" label="Radnik"
            v-model="noviRadnik" @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Datum"
            v-model="noviDatum" type="date"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Sati"
            v-model.number="noviSati" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Satnica"
            v-model.number="novaSatnica" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Dnevnice"
            v-model.number="noveDnevnice" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Kilometri"
            v-model.number="noviKilometri" type="number" class="polje-broj"
            @keyup.enter="dodaj"></v-text-field>
          <v-text-field outlined dense hide-details="auto" label="Vrijednost"
            :value="localMoney(novaVrijednost)" readonly class="polje-broj"></v-text-field>
          <div class="gumbi">
            <v-btn color="primary" small :disabled="!smijeDodati" @click="dodaj">
              {{ uredujem ? 'Spremi' : 'Dodaj' }}
            </v-btn>
            <v-btn text small v-if="uredujem" @click="odustani">Odustani</v-btn>
          </div>
        </div>
        <div class="greska" v-if="greske.length">{{ greske.join(' ') }}</div>

        <v-data-table
            :headers="headers" :items="items" :search="search"
            hide-default-footer :items-per-page="-1" item-key="id" dense
            :mobile-breakpoint="0" @click:row="navigateTo">
          <template v-slot:[`item.empWrkHrs`]="{ item }">{{ localMoney(item.empWrkHrs) }}</template>
          <template v-slot:[`item.empWrkExpHrs`]="{ item }">{{ localMoney(item.empWrkExpHrs) }}</template>
          <template v-slot:[`item.empExp1`]="{ item }">{{ localMoney(item.empExp1) }}</template>
          <template v-slot:[`item.empExp2`]="{ item }">{{ localMoney(item.empExp2) }}</template>
          <template v-slot:[`item.itemBaseAmount`]="{ item }">{{ localMoney(item.itemBaseAmount) }}</template>
          <template v-slot:[`body.append`]>
            <tr class="zbroj-red">
              <td colspan="6" class="text-end">Ukupno</td>
              <td class="text-end">{{ localMoney(zbrojSkupine) }}</td>
              <td></td>
            </tr>
          </template>
          <template v-slot:[`item.obrisi`]="{ item }">
            <v-icon small color="red darken-1" @click.stop="obrisi(item)"
                    title="Obriši stavku">mdi-delete-outline</v-icon>
          </template>
          <template v-slot:no-data>Rad nije upisan — u koštanju je tada samo materijal.</template>
        </v-data-table>
      </v-card>

</template>

<script>
import moneyFormat from '@/snippets/moneyFormat'
import { slozi, provjeri, zbrojNaloga, RAD } from './radniNalogZapis'

export default {
  computed: {
    // Iznos rada: sati x satnica, plus dnevnice i kilometri.
    novaVrijednost () {
      const n = (v) => parseFloat(v) || 0
      return Math.round((n(this.noviSati) * n(this.novaSatnica) + n(this.noveDnevnice) + n(this.noviKilometri)) * 100) / 100
    },
    uredujem () { return this.urediIndex >= 0 },
    smijeDodati () {
      return (parseFloat(this.noviSati) || 0) > 0 && (parseFloat(this.novaSatnica) || 0) > 0
    },
    // Jezik se cita jednom, a ne u svakom stupcu posebno.
    en () {
      return this.$store.state.language === 'EN'
    },
    // Zbroj skupine stoji u naslovu - prije se vidio tek u financijskoj
    // kartici, nakon sto se prolista cijela tablica.
    zbrojSkupine () {
      return (this.items || []).reduce((z, s) => z + (parseFloat(s.itemBaseAmount) || 0), 0)
    },
    mnozinaStavke () {
      const n = (this.items || []).length
      return n === 1 ? 'stavka' : (n >= 2 && n <= 4 ? 'stavke' : 'stavaka')
    }
  },
  name: 'documentdetaillist31',
  data () {
    return {
      msg: '',
      items: [],
      locked: false,
      noviRadnik: '',
      noviDatum: null,
      noviSati: null,
      novaSatnica: null,
      noveDnevnice: null,
      noviKilometri: null,
      greske: [],
      urediIndex: -1,
      max25chars: (v) => v.length <= 25 || 'Input too long!',
      tmp: '',
      search: '',
      pagination: {},
      rowsPerPageItems: [50],
      headers: [ ],
      mainQuery: {
        CompanyId: 1,
        businessYear: 0,
        documentName: '',
        databaseDocID: 0,
        FreeF1: 2
      }
    }
  },
  async mounted () {
    try {
      if (this.$store.state.companyid) {
        this.mainQuery.CompanyId = this.$store.state.companyid
      }
      if (this.$store.state.businessYear) {
        this.mainQuery.businessYear = this.$store.state.businessYear
      }
      if (this.$store.state.documentActiv) {
        this.mainQuery.documentName = this.$store.state.documentActiv
      }
      if (this.$store.state.databaseDocID) {
        this.mainQuery.databaseDocID = this.$store.state.databaseDocID
      }
      this.locked = this.$store.state.documentActivHead &&
        this.$store.state.documentActivHead.documentLocked === true
      this.mainQuery.FreeF1 = 2
      
      this.items = this.$store.state.documentActivItems.filter(item => {
            return parseInt(item.FreeF6)  === 31
          })
  
      // Rad se vodi po radniku i satima; iznosi desno, interni id maknut.
      this.headers = [
        { text: this.en ? 'Worker' : 'Radnik', align: 'start', value: 'hashtag' },
        { text: this.en ? 'Date' : 'Datum', align: 'start', value: 'empWorkDay', width: '110px' },
        { text: this.en ? 'Hours' : 'Sati', align: 'end', value: 'empWrkHrs', width: '90px' },
        { text: this.en ? 'Rate' : 'Satnica', align: 'end', value: 'empWrkExpHrs', width: '110px' },
        { text: this.en ? 'Daily' : 'Dnevnice', align: 'end', value: 'empExp1', width: '110px' },
        { text: this.en ? 'Km' : 'Kilometri', align: 'end', value: 'empExp2', width: '110px' },
        { text: this.en ? 'Value' : 'Vrijednost', align: 'end', value: 'itemBaseAmount', width: '130px' },
        { text: '', value: 'obrisi', align: 'center', sortable: false, width: '48px' }
      ]
    } catch (error) {
      // eslint-disable-next-line
      console.log(error)
    }
  },
  methods: {
    podaciRada () {
      return {
        skupina: RAD,
        glava: this.$store.state.documentActivHead || {},
        rad: {
          radnik: this.noviRadnik,
          datum: this.noviDatum,
          sati: this.noviSati,
          satnica: this.novaSatnica,
          dnevnice: this.noveDnevnice,
          kilometri: this.noviKilometri
        },
        databaseDocID: this.$store.state.databaseDocID,
        korisnik: this.$store.state.user ? this.$store.state.user.email : ''
      }
    },
    dodaj () {
      const podaci = this.podaciRada()
      this.greske = provjeri(podaci)
      if (this.greske.length) { return }
      const stavke = (this.$store.state.documentActivItems || []).slice()
      const nova = slozi(podaci)
      if (this.urediIndex >= 0) {
        nova.id = stavke[this.urediIndex] ? stavke[this.urediIndex].id : undefined
        stavke.splice(this.urediIndex, 1, nova)
      } else {
        stavke.push(nova)
      }
      this.spremiUStore(stavke)
      this.ocisti()
      this.$nextTick(() => { if (this.$refs.radnik) { this.$refs.radnik.focus() } })
    },
    spremiUStore (stavke) {
      this.$store.dispatch('setDocumentActivItems', stavke)
      const glava = Object.assign({}, this.$store.state.documentActivHead, zbrojNaloga(stavke))
      this.$store.dispatch('setDocumentActivHead', glava)
      this.osvjezi()
    },
    ocisti () {
      this.noviRadnik = ''
      this.noviDatum = null
      this.noviSati = null
      this.novaSatnica = null
      this.noveDnevnice = null
      this.noviKilometri = null
      this.urediIndex = -1
      this.greske = []
    },
    odustani () { this.ocisti() },
    obrisi (item) {
      if (this.locked) { return }
      if (!confirm('Obrisati stavku rada ' + (item.hashtag || '') + '?')) { return }
      const stavke = (this.$store.state.documentActivItems || []).slice()
      const i = stavke.indexOf(item)
      if (i === -1) { return }
      stavke.splice(i, 1)
      this.spremiUStore(stavke)
      if (this.urediIndex === i) { this.ocisti() }
    },
    osvjezi () {
      this.items = (this.$store.state.documentActivItems || []).filter(item => {
        return parseInt(item.FreeF6) === 31
      })
    },
    localMoney(moneyToFormat) {
      return moneyFormat(moneyToFormat)
    },
    // Klik na stavku puni gornji redak za ispravak.
    navigateTo (item) {
      if (this.locked) { return }
      this.greske = []
      this.urediIndex = (this.$store.state.documentActivItems || []).indexOf(item)
      this.noviRadnik = item.hashtag || ''
      this.noviDatum = item.empWorkDay ? String(item.empWorkDay).substring(0, 10) : null
      this.noviSati = parseFloat(item.empWrkHrs) || 0
      this.novaSatnica = parseFloat(item.empWrkExpHrs) || 0
      this.noveDnevnice = parseFloat(item.empExp1) || 0
      this.noviKilometri = parseFloat(item.empExp2) || 0
    },
    newMaterial () {
      this.$store.dispatch('seteditItem', 0)
      this.$store.dispatch('settypePOS', 31)
      // warehouse not use
      this.$store.dispatch('setDocumentSide', 3) 
      this.$router.push({
        name: 'documentdetailcreateedit3'
      })
    }
  },
  watch: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/* Naslov skupine. "v-card-title" je flex spremnik, pa razmaci izmedu elemenata
   nestaju - svaki razmak mora doci iz margine, inace se tekst slijepi
   ("materijala- razduzuje skladiste14 stavaka").
   Boja NIJE jedini znak skupine: uz nju idu glif i rijec, pa se razlika vidi i
   na crno-bijelom ispisu. */
.naslov-kartice {
  font-size: 17px;
  font-weight: 700;
  letter-spacing: 0.02em;
  color: #1565c0;
  background: #eef4fb;
  border-bottom: 2px solid #1976d2;
  padding: 8px 14px;
  min-height: 0;
  flex-wrap: nowrap;
}
.naslov-kartice .glif { margin-right: 8px; font-size: 15px; line-height: 1; }
.naslov-kartice .smjer {
  font-size: 12px;
  font-weight: 400;
  letter-spacing: 0;
  padding: 2px 9px;
  border-radius: 10px;
  margin-left: 12px;
  white-space: nowrap;
}
.naslov-kartice .znak {
  font-size: 13px;
  font-weight: 400;
  color: rgba(0, 0, 0, 0.6);
  margin-left: 12px;
  white-space: nowrap;
}
.naslov-kartice .iznos {
  font-size: 16px;
  font-weight: 700;
  font-variant-numeric: tabular-nums;
  margin-left: 12px;
}
.utroseno .naslov-kartice { color: #8a4b00; background: #fff8f0; border-bottom-color: #ef6c00; }
.utroseno .naslov-kartice .smjer { background: #ffe0b2; color: #8a4b00; }
.rad .naslov-kartice { color: #4527a0; background: #f5f3fb; border-bottom-color: #5e35b1; }
.rad .naslov-kartice .smjer { background: #ede7f6; color: #4527a0; }
.ostalo .naslov-kartice { color: #0d47a1; background: #eef4fb; border-bottom-color: #1976d2; }
.ostalo .naslov-kartice .smjer { background: #e3f2fd; color: #0d47a1; }
.proizvedeno .naslov-kartice { color: #1b5e20; background: #f1f8f1; border-bottom-color: #43a047; }
.proizvedeno .naslov-kartice .smjer { background: #c8e6c9; color: #1b5e20; }
.kol { font-weight: 600; }
.dobit { font-weight: 600; color: #1b5e20; }
.zbroj-red td {
  font-weight: 700;
  border-top: 2px solid #e0e0e0;
  background: #fafafa;
  font-variant-numeric: tabular-nums;
}
.unos-rad {
  display: grid;
  grid-template-columns: 1fr 150px 90px 110px 110px 110px 130px auto;
  gap: 8px;
  align-items: center;
  padding: 10px 14px;
  background: #f5f3fb;
  border-bottom: 1px solid #e0e0e0;
}
.unos-rad .polje-broj >>> input { text-align: right; }
.unos-rad .gumbi { display: flex; gap: 4px; align-items: center; }
.greska { padding: 6px 14px; color: #c62828; font-size: 13px; }
@media (max-width: 1200px) { .unos-rad { grid-template-columns: 1fr 1fr; } }
</style>
